module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-09-9b0dbb4d26d168f04521e6940e09beb1.png";